/* eslint-disable import/no-webpack-loader-syntax */
import { last } from 'lodash';
import dts from '!!raw-loader!./wuji-flow.d.ts';
import { workflowEntityApi, flowApi } from '@/services';
export async function getTypeDefinitions() {
    return dts;
}
export default class WujiFlow {
    async startBasicFlow(id, params, extraPayload) {
        return await workflowEntityApi.start(window.w.projectId, window.w.env, id, { ...params, _wuji_extra_data: extraPayload });
    }
    async getBasicFlowService(entityId) {
        const { projectId, env } = window.w;
        const entity = await workflowEntityApi.fetchWorkflowEntity(projectId, env, entityId);
        return new BasicFlowService(entity);
    }
    async fetchMyEntityList(pageInfo) {
        const { projectId, env } = window.w;
        return await workflowEntityApi.fetchEntities(projectId, env, 'created', pageInfo);
    }
    async fetchMyEntityListTotal(pageInfo) {
        const { projectId, env } = window.w;
        const resp = await workflowEntityApi.fetchEntities(projectId, env, 'created', { ...pageInfo, count: 1 });
        return resp.total;
    }
    async fetchPendingEntityList(pageInfo) {
        const { projectId, env } = window.w;
        return await workflowEntityApi.fetchEntities(projectId, env, 'pending', pageInfo);
    }
    async fetchPendingEntityListTotal(pageInfo) {
        const { projectId, env } = window.w;
        const resp = await workflowEntityApi.fetchEntities(projectId, env, 'pending', { ...pageInfo, count: 1 });
        return resp.total;
    }
    async fetchRelatedEntityList(pageInfo) {
        const { projectId, env } = window.w;
        return await workflowEntityApi.fetchEntities(projectId, env, 'related', pageInfo);
    }
    async fetchRelatedEntityListTotal(pageInfo) {
        const { projectId, env } = window.w;
        const resp = await workflowEntityApi.fetchEntities(projectId, env, 'related', { ...pageInfo, count: 1 });
        return resp.total;
    }
    async startAdvancedFlow(id, params) {
        return await flowApi.startFlow(window.w.projectId, id, params);
    }
    async getAdvancedFlowService(jobId) {
        const { projectId } = window.w;
        const job = await flowApi.fetchJob(projectId, '', jobId);
        return new AdvancedFlowService(job);
    }
    async fetchMyJobList(title, pageInfo) {
        const { projectId } = window.w;
        return await flowApi.fetchJobListByType(projectId, title, 'created', pageInfo);
    }
    async fetchMyJobListTotal(title, pageInfo) {
        const { projectId } = window.w;
        const resp = await flowApi.fetchJobListByType(projectId, title, 'created', { ...pageInfo, count: 1 });
        return resp.total;
    }
    async fetchPendingJobList(title, pageInfo) {
        const { projectId } = window.w;
        return await flowApi.fetchJobListByType(projectId, title, 'pending', pageInfo);
    }
    async fetchPendingJobListTotal(title, pageInfo) {
        const { projectId } = window.w;
        const resp = await flowApi.fetchJobListByType(projectId, title, 'pending', { ...pageInfo, count: 1 });
        return resp.total;
    }
    async fetchRelatedJobList(title, pageInfo) {
        const { projectId } = window.w;
        return await flowApi.fetchJobListByType(projectId, title, 'participated', pageInfo);
    }
    async fetchRelatedJobListTotal(title, pageInfo) {
        const { projectId } = window.w;
        const resp = await flowApi.fetchJobListByType(projectId, title, 'participated', { ...pageInfo, count: 1 });
        return resp.total;
    }
}
class BasicFlowService {
    data;
    constructor(data) {
        this.data = data;
        this.data.approvalPayload = JSON.parse(data.payload);
    }
    getEntityData() {
        return this.data;
    }
    async approve(data) {
        const { projectId, env, _id: id } = this.data;
        this.data = await workflowEntityApi.transition(projectId, env, id, { ...data, currentStatus: this.data.status });
        return this.data;
    }
    async restart(payload) {
        const { projectId, env, _id: id } = this.data;
        this.data = await workflowEntityApi.restart(projectId, env, id, payload);
        return this.data;
    }
    async abort(comment) {
        const { projectId, env, _id: id } = this.data;
        this.data = await workflowEntityApi.abort(projectId, env, id, { comment });
        return this.data;
    }
    async assignHandlers(handlers) {
        const { projectId, env, _id: id } = this.data;
        this.data = await workflowEntityApi.assignHandlers(projectId, env, id, handlers);
        return this.data;
    }
    async fetchRecordList() {
        const { projectId, env, _id: id } = this.data;
        const records = await workflowEntityApi.fetchEntityRecords(projectId, env, id);
        return records;
    }
    isProcessing() {
        return this.data.flowStatus === 'processing';
    }
    canApprove() {
        const { userId } = window.w.user;
        return this.isProcessing() && this.data.handlers.split(',').includes(userId);
    }
}
class AdvancedFlowService {
    data;
    constructor(data) {
        this.data = data;
        this.data = data;
    }
    getJobData() {
        return this.data;
    }
    async approve(data) {
        const nodeId = last(this.data.detailBlocks)?.nodeId;
        return await flowApi.approval(this.data.projectId, nodeId, this.data.id, data.operation, data.comment, data.form);
    }
    async fetchApprovalNodeInfo(jobId, nodeId) {
        return await flowApi.fetchApprovalNodeInfo(jobId, nodeId);
    }
    async fetchLogNodeInfo(jobId, nodeId, tickId) {
        return await flowApi.fetchLogNodeInfo(jobId, nodeId, tickId);
    }
}
